import styled from 'styled-components';

export const ButtonsRow = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
});

export const ButtonCell = styled.div({
  display: 'flex',
  justifyContent: 'center',
});
